import React from 'react';

import css from './SectionTitle.module.css';

interface IProps {
  className?: string;
}

const SectionTitle: React.FC<React.PropsWithChildren<IProps>> = ({ children, className = '' }) => (
  <>
    <h2 className={`${css.title} ${className}`}>{children}</h2>
    <hr className={css.divider} />
  </>
);

export default SectionTitle;
